import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    notificationList: [],
    unreadCount: 0,
}

const notificationSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        setNotifications: (state, action) => {
            state.notificationList = action.payload;
            state.unreadCount = action.payload.filter(n => n?.ND_is_read === 0).length;
        },
        clearNotifications: (state) => {
            state.notificationList = [];
            state.unreadCount = 0;
        },
    }
});

export const { setNotifications, clearNotifications } = notificationSlice.actions
export default notificationSlice.reducer